import clsx from 'clsx'
import {
  getTenantCustomImage,
  getTenantName,
  isAuthGradientDomain,
  isSelectiveAiDomains,
  isUniversalLoginHost,
} from 'common/HelperFunctions'
import Logo from 'common/components/Logo'
import {BUILD_VERSION} from 'common/constants'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, Outlet} from 'react-router'
import {getGeneralSettings} from 'setup/redux/Actions/General/settings'

import {toAbsoluteUrl} from '_metronic/helpers'

const AuthLayout = () => {
  const dispatch = useDispatch()

  const generalSettings = useSelector<any>(({mainReducer}) => mainReducer.generalSettings) as any
  const generalSettingsLoaded = useSelector<any>(
    ({mainReducer}) => mainReducer.generalSettingsLoaded
  ) as boolean

  const defaultBackgroundUrl = toAbsoluteUrl('/media/background/6.png')
  const [backgroundUrl, setBackgroundUrl] = useState('')

  const initBackgroundImage = () => {
    const customBackgroundImage = getTenantCustomImage('background_image')
    if (customBackgroundImage) setBackgroundUrl(customBackgroundImage)
    else if (generalSettings.background_image) setBackgroundUrl(generalSettings.background_image)
    // Until the server answers, an empty setting means "not asked yet" — leave the
    // plain white ground rather than flashing the default at a branded tenant.
    else if (generalSettingsLoaded) setBackgroundUrl(defaultBackgroundUrl)
  }

  useEffect(() => {
    if (!isUniversalLoginHost()) {
      dispatch(getGeneralSettings())
    }
    initBackgroundImage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    initBackgroundImage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalSettings, generalSettingsLoaded])

  const isSpecialDomain = isAuthGradientDomain()

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed position-relative min-vh-100'
      data-selective-ai-domain={isSelectiveAiDomains() ? 'true' : undefined}
      style={
        isSpecialDomain
          ? {
              background: 'linear-gradient(90.14deg, #0D0E12 20.07%, #431214 99.87%)',
              backgroundSize: 'cover',
            }
          : {
              backgroundColor: '#fff',
              backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : undefined,
              backgroundSize: 'cover',
              backgroundPositionX: 'center',
              backgroundPositionY: 'center',
              backgroundRepeat: 'no-repeat',
            }
      }
    >
      {/* begin::Content */}
      {/* 'safe center': keep the card centred, but fall back to top-aligned once it is
          taller than the viewport (e.g. when an error alert appears) so nothing is pushed
          into unreachable overflow — the page simply scrolls. */}
      <div
        className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20 position-relative'
        style={{justifyContent: 'safe center'}}
      >
        {/* begin::Logo */}
        <Link
          to='/auth/login'
          className={clsx(
            isSpecialDomain && 'position-absolute top-0 start-0 p-10 text-decoration-none',
            !isSpecialDomain && 'mb-12'
          )}
        >
          {isSpecialDomain ? (
            <span className='d-flex align-items-center gap-2 text-white fw-bold fs-4'>
              <img
                src={toAbsoluteUrl('/media/auth/image 70.png')}
                alt='Logo'
                style={{maxHeight: '48px'}}
              />
              Timetable™
            </span>
          ) : (
            <Logo showBranchLogo={false} style={{maxHeight: '200px'}} />
          )}
        </Link>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div
          className={clsx(
            'w-100 shadow-sm mx-auto',
            isSpecialDomain
              ? 'mw-680px p-8 p-lg-12 mt-0 mt-lg-6'
              : 'mw-550px w-lg-50 p-10 p-lg-15 rounded',
            !isSpecialDomain && 'bg-body'
          )}
          style={
            isSpecialDomain
              ? {
                  background: 'rgba(40, 30, 35, 0.9)',
                  backdropFilter: 'blur(16px)',
                  borderRadius: 24,
                  border: '1.5px solid rgba(59, 130, 246, 0.55)',
                  boxShadow: '0 0 32px rgba(59, 130, 246, 0.12)',
                  maxWidth: 680,
                }
              : undefined
          }
        >
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        <div
          className={clsx(
            'd-flex gap-5 align-items-center fw-bold fs-6',
            isSpecialDomain && 'text-white'
          )}
        >
          {/* {!generalSettings?.powered_by_text && (
            <span>
              Powered by
              <a
                href='https://ilmversity.com'
                target='_blank'
                className='text-dark text-hover-primary px-2'
                rel='noreferrer'
              >
                Ilmversity
              </a>
            </span>
          )} */}
          {getTenantName() !== 'lgs' && !!generalSettings?.powered_by_text && (
            <div dangerouslySetInnerHTML={{__html: generalSettings?.powered_by_text}} />
          )}
          <div>Build: {BUILD_VERSION}</div>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}

export {AuthLayout}
